import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import "./style.css";
import "./style2.css";
import Swal from "sweetalert2";
import loadConfig from "../../Services/apiService";
import { useDispatch, useSelector } from "react-redux";
import { UpdateAdvertisingPlan } from "../../Redux/Reducers/AdvertisingAndMediaPlanForTheProject";
import UpdatestateApplicationInformationPage from "../../Services/ApplicantInformationPage/UpdateApplicantInformation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGears,
  faTicket,
  faUser,
  faUserPlus,
  faCogs,
  faPeopleArrows,
  faTable,
} from "@fortawesome/free-solid-svg-icons";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
function NavBarManager() {
  const [activeLink, setActiveLink] = useState(window.location.pathname);
  const [menuOpen, setMenuOpen] = useState(false);
  const [jsonData, setJsonData] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      ApplicationInformationloding: state.ApplicationInformation,
      BeneficiaryInformation:
        state.BeneficiaryInformation.BeneficiaryInformation,
      GeneralInformation: state.GeneralInformation.GeneralInformation,
      PersonalInformation: state.PersonalInformation.PersonalInformation,
      AdvertisingAndMediaPlanForTheProject:
        state.AdvertisingAndMediaPlanForTheProject
          .AdvertisingAndMediaPlanForTheProject,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      RoleByUserGuid: state.RoleByUserGuid.RoleByUserGuid,
    };
  });
  // const handleLinkClick = async (path) => {
  //   navigate(`/grants/manager${path}`);
  //   setActiveLink(`/grants/manager${path}`);
  //   setMenuOpen(false);
  // };

  // const getBackgroundColor = (path) => {
  //   return activeLink === path || activeLink.includes(path)
  //     ? "#fff"
  //     : "#dbdbdbab";
  // };
  // const getTextColor = (path) => {
  //   return activeLink === path || activeLink.includes(path)
  //     ? "#034e84"
  //     : "#034e84";
  // };
  // const getboxShadow = (path) => {
  //   return activeLink === path || activeLink.includes(path)
  //     ? "1px 1px 1px 1px rgb(9 54 111 / 51%)"
  //     : "none";
  // };
  // const gettextDecoration = (path) => {
  //   return activeLink === path || activeLink.includes(path) ? "none" : "none";
  // };
  // const getBorderBottom = (path) => {
  //   return activeLink === path || activeLink.includes(path)
  //     ? "3.5px solid #18647f"
  //     : "none";
  // };
  // let jsonData = {};
  console.log(state.RoleByUserGuid, "ssssssssssdwdwdwdwd");

  const dataJson = async () => {
    let jsonData = await loadConfig();

    setJsonData(jsonData);
  };

  useEffect(() => {
    dataJson();
  }, []);
  if (state.RoleByUserGuid?.includes(
    "ee74a1f0-bfdf-4ff3-bfc9-92d34ed9c41f"
  )) {
    return (<>
      {jsonData ? (

        <div className="containerr">
          <div className="input">
            <Link
              to="/grants/manager/RequestsManager"
              className={`navbar-link ${activeLink === "/grants/manager/RequestsManager"
                  ? "active"
                  : ""
                }`}
              id="navbar-link1"
              onClick={() => setActiveLink("/grants/manager/RequestsManager")}
            >
              <button className="value">
                <FontAwesomeIcon icon={faTicket} />
                &nbsp;
                {jsonData.RequestsManager.nameAR}
              </button>
            </Link>

            <Link
              to="/grants/manager/Report"
              className={`navbar-link ${activeLink === "/grants/manager/Report" ? "active" : ""
                }`}
              id="navbar-link2"
              onClick={() => setActiveLink("/grants/manager/Report")}
            >
              <button className="value">
                <FontAwesomeIcon icon={faGears} />
                &nbsp;
                {jsonData.RS_ReportStagesNav.nameAR}
              </button>
            </Link>

          </div>
        </div>
      ) : (
        ""
      )}
    </>)
  } 
  else {
    return (
      <>
        {jsonData ? (

          <div className="containerr">
            <div className="input">
              {state.RoleByUserGuid?.includes(
                "2e2f0a6c-54b0-4eb2-8741-55b23282a790"
              )||state.RoleByUserGuid?.includes(
                "aa7d988b-0044-4034-9b75-40da32534726"
              ) ||state.RoleByUserGuid?.includes(
                "9ee77ff6-a48b-46c8-9eb6-1a2337810f19"
              )? (
                <Link
                  to="/grants/manager/RequestsManager"
                  className={`navbar-link ${activeLink === "/grants/manager/RequestsManager"
                      ? "active"
                      : ""
                    }`}
                  id="navbar-link1"
                  onClick={() => setActiveLink("/grants/manager/RequestsManager")}
                >
                  <button className="value">
                    <FontAwesomeIcon icon={faTicket} />
                    &nbsp;
                    {jsonData.RequestsManager.nameAR}
                  </button>
                </Link>
              ) : (
                <></>
              )}



              {
                state.RoleByUserGuid?.includes(
                "2e2f0a6c-54b0-4eb2-8741-55b23282a790"
              )||state.RoleByUserGuid?.includes(
                "aa7d988b-0044-4034-9b75-40da32534726"
              )?
              <Link
                to="/grants/manager/TasksManager"
                className={`navbar-link ${activeLink === "/grants/manager/TasksManager" ? "active" : ""
                  }`}
                id="navbar-link2"
                onClick={() => setActiveLink("/grants/manager/TasksManager")}
              >
                <button className="value">
                  <FontAwesomeIcon icon={faGears} />
                  &nbsp;
                  {jsonData.TasksManager.nameAR}
                </button>
              </Link>
              :<></>
              }
              

              {state.RoleByUserGuid?.includes(
                "7382e598-e8b5-4077-aee6-cfdfd8b16e4f"
              ) ? (
                <Link
                  to="/grants/manager/AssiginToEvaluters"
                  className={`navbar-link ${activeLink === "/grants/manager/AssiginToEvaluters"
                      ? "active"
                      : ""
                    }`}
                  id="navbar-link2"
                  onClick={() =>
                    setActiveLink("/grants/manager/AssiginToEvaluters")
                  }
                >
                  <button className="value">
                    <FontAwesomeIcon icon={faUserPlus} />
                    &nbsp;
                    {jsonData.AssiginToEvaluters.nameAR}
                  </button>
                </Link>
              ) : (
                ""
              )}
              {state.RoleByUserGuid?.includes(
                "2e2f0a6c-54b0-4eb2-8741-55b23282a790"
              )||state.RoleByUserGuid?.includes(
                "aa7d988b-0044-4034-9b75-40da32534726"
              ) ? (
                <Link
                  to="/grants/manager/MyRequestsPage"
                  className={`navbar-link ${activeLink === "/grants/manager/MyRequestsPage"
                      ? "active"
                      : ""
                    }`}
                  id="navbar-link2"
                  onClick={() => setActiveLink("/grants/manager/MyRequestsPage")}
                >
                  <button className="value">
                    <FontAwesomeIcon icon={faTable} />
                    &nbsp;
                    {jsonData.MyRequestsManager.nameAR}
                  </button>
                </Link>
              ) : (
                ""
              )}
              {/* <Link to="" className="navbar-link" id="navbar-link1">
              <button class="value">
                <FontAwesomeIcon icon={faUser} />
                &nbsp; شاشة المحكمين على الجوائز
              </button>
            </Link> */}
              {/* <Link to="" className="navbar-link" id="navbar-link1">
              <button class="value">
                <FontAwesomeIcon icon={faUserPlus} />
                &nbsp; اضافة محكم على الجائزة
              </button>
            </Link> */}

                {
                  state.RoleByUserGuid?.includes(
                "2e2f0a6c-54b0-4eb2-8741-55b23282a790"
              )||state.RoleByUserGuid?.includes(
                "aa7d988b-0044-4034-9b75-40da32534726"
              )||state.RoleByUserGuid?.includes(
                "ea4c6bb6-98f4-4618-befa-259847b5db64"
              )||state.RoleByUserGuid?.includes(
                "9ee77ff6-a48b-46c8-9eb6-1a2337810f19"
              )?
               <Link
                to="/grants/manager/Report"
                className={`navbar-link ${activeLink === "/grants/manager/Report" ? "active" : ""
                  }`}
                id="navbar-link2"
                onClick={() => setActiveLink("/grants/manager/Report")}
              >
                <button className="value">
                  <FontAwesomeIcon icon={faGears} />
                  &nbsp;
                  {jsonData.RS_ReportStagesNav.nameAR}
                </button>
              </Link>
              :<></>
                }

             

            </div>
          </div>
        ) : (
          ""
        )}
      </>
    );
  }

}

export default NavBarManager;
